import { supabase } from '../lib/supabase';

const SESSION_WAIT_MS = 10_000;

/**
 * Wait until Supabase client has a JWT session (after verifyOtp).
 */
export function waitForAuthSession(timeoutMs = SESSION_WAIT_MS) {
  return new Promise((resolve, reject) => {
    let settled = false;
    const finish = (session) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      sub?.unsubscribe();
      resolve(session);
    };
    const fail = (err) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      sub?.unsubscribe();
      reject(err instanceof Error ? err : new Error(String(err)));
    };

    const timer = setTimeout(
      () => fail(new Error('تعذر تأكيد الجلسة. حاول مرة أخرى.')),
      timeoutMs
    );

    const { data: { subscription: sub } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session?.access_token) finish(session);
    });

    void supabase.auth.getSession().then(({ data: { session }, error }) => {
      if (error) fail(error);
      else if (session?.access_token) finish(session);
    });
  });
}

/**
 * Apply Edge Function verify-otp-and-signin response and establish local session.
 */
export async function applyOtpVerifyResponse(data) {
  if (data?.error) throw new Error(data.error);

  if (data?.redirectUrl) {
    const url = new URL(data.redirectUrl);
    const tokenHash = url.searchParams.get('token');
    if (!tokenHash) throw new Error('فشل الحصول على رمز الدخول');
    const { error: verifyError } = await supabase.auth.verifyOtp({
      token_hash: tokenHash,
      type: 'email',
    });
    if (verifyError) throw verifyError;
  } else if (!data?.success) {
    throw new Error('فشل التحقق');
  }

  await waitForAuthSession();
}
